module.exports = __webpack_public_path__ + "static/avatar-be33967ed0c3cc1aba712a3bfa963935.png";